import { apiConnector } from '../apiConnector';
import { unitEndpoint } from '../api';

export const updateUnit = async (id, unitData) => {
	let result = {};
	try {
		const response = await apiConnector('PUT', unitEndpoint.UPDATE_UNIT(id), unitData);
		result = response.data;
	} catch (error) {
		console.error('UPDATE UNIT API ERROR', error);
		result = error.response?.data || { success: false, message: error.message };
	}
	return result;
};

export const deleteUnit = async (id) => {
	let result = {};
	try {
		const response = await apiConnector('DELETE', unitEndpoint.DELETE_UNIT(id));
		result = response.data;
	} catch (error) {
		console.error('DELETE UNIT API ERROR', error);
		result = error.response?.data || { success: false, message: error.message };
	}
	return result;
};

export const getUnitsBySubject = async (subjectId, dispatch) => {
	let result = [];
	try {
		const response = await apiConnector('GET', unitEndpoint.GET_UNITS_BY_SUBJECT(subjectId));
		if (!response.data || !response.data.success) throw new Error('Could not fetch units for subject');
		result = response.data;
	} catch (error) {
		console.error('GET UNITS BY SUBJECT API ERROR', error);
		result = error.response?.data || { success: false, message: error.message };
	}
	return result;
};

export const addUnit = async (subjectId, unitData, dispatch) => {
	let result = {};
	try {
		const response = await apiConnector('POST', unitEndpoint.ADD_UNIT(subjectId), unitData);
		result = response.data;
	} catch (error) {
		console.error('ADD UNIT API ERROR', error);
		result = error.response?.data || { success: false, message: error.message };
	}
	return result;
};

